import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: '',
    type: 'text',
    width: 45,
  },
  {
    key: 'dependencySupportRevenue',
    header: 'Revenue Supported',
    type: 'money',
    width: 40,
  },
  {
    key: 'mitigation.onsitePercentage',
    header: 'Onsite Mitigation - Percentage (%)',
    type: 'percentage',
    width: 35,
  },
  {
    key: 'mitigation.onsiteDelay',
    header: 'Onsite Mitigation - Delay (mths)',
    type: 'number',
    width: 35,
  },
  {
    key: 'mitigation.internalPercentage',
    header: 'Internal Mitigation - Percentage (%)',
    type: 'percentage',
    width: 35,
  },
  {
    key: 'mitigation.internalDelay',
    header: 'Internal Mitigation - Delay (mths)',
    type: 'number',
    width: 35,
  },
  {
    key: 'mitigation.externalPercentage',
    header: 'External Mitigation - Percentage (%)',
    type: 'percentage',
    width: 35,
  },
  {
    key: 'mitigation.externalDelay',
    header: 'External Mitigation - Delay (mths)',
    type: 'number',
    width: 35,
  },
  {
    key: 'mitigation.strategyComment',
    header: 'Strategy Comment',
    type: 'text',
    placeholder: 'No Comment',
    width: 150,
  },
];
